import { defineComponent as i, computed as f, createElementBlock as n, openBlock as o, createElementVNode as e, toDisplayString as a, Fragment as b, renderList as _ } from "vue";
import { Constants as j } from "@magnolia/frontend-helpers-base";
const E = /* @__PURE__ */ i({
  name: "DefaultFallbackComponent",
  __name: "DefaultFallbackComponent",
  props: {
    metadata: {},
    data: {}
  },
  setup(m) {
    const u = m, p = f(
      () => {
        var t;
        return (t = u.metadata) == null ? void 0 : t[j.TEMPLATE_ID_PROP];
      }
    ), c = (t) => t === "[object Object]" ? "[object]" : t, s = (t) => c("" + t);
    return (t, l) => (o(), n("div", null, [
      e("div", null, [
        e("strong", null, [
          e("em", null, "Template not found: " + a(p.value), 1)
        ])
      ]),
      (o(!0), n(b, null, _(t.data, (d, r) => (o(), n("div", { key: r }, a(r) + ": " + a(s(d)), 1))), 128)),
      l[0] || (l[0] = e("br", null, null, -1))
    ]));
  }
});
export {
  E as default
};
//# sourceMappingURL=vue-editor2.js.map
